/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdLabel
 */
export interface IdLabel {
    /**
     * 
     * @type {string}
     * @memberof IdLabel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IdLabel
     */
    label: string;
}

/**
 * Check if a given object implements the IdLabel interface.
 */
export function instanceOfIdLabel(value: object): value is IdLabel {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function IdLabelFromJSON(json: any): IdLabel {
    return IdLabelFromJSONTyped(json, false);
}

export function IdLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdLabel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
    };
}

export function IdLabelToJSON(json: any): IdLabel {
    return IdLabelToJSONTyped(json, false);
}

export function IdLabelToJSONTyped(value?: IdLabel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
    };
}

